import dogBreeds from "../data/breeds/dog.json";
import catBreeds from "../data/breeds/cat.json";
import { t } from "../i18n";

export const SPECIES_KEYS = [
  "dog",
  "cat",
  "rabbit",
  "bird",
  "horse",
  "rodent",
  "reptile",
  "fish",
  "other",
] as const;

export type SpeciesKey = (typeof SPECIES_KEYS)[number];

/** @deprecated use SPECIES_KEYS */
export const SPECIES_OPTIONS = SPECIES_KEYS.map((key) => ({
  value: key,
  key,
}));

const BREEDS_BY_KEY: Record<string, readonly string[]> = {
  dog: dogBreeds as string[],
  cat: catBreeds as string[],
};

const IT_LABEL_TO_KEY: Record<string, SpeciesKey> = {
  Cane: "dog",
  Gatto: "cat",
  Coniglio: "rabbit",
  Uccello: "bird",
  Cavallo: "horse",
  Roditore: "rodent",
  Rettile: "reptile",
  Pesce: "fish",
  Altro: "other",
};

export function speciesLabel(key: SpeciesKey): string {
  return t(`breeds.species.${key}`);
}

export function speciesOptionsHtml(): string {
  return SPECIES_KEYS.map(
    (key) => `<option value="${key}">${speciesLabel(key)}</option>`,
  ).join("");
}

export function speciesKeyFromLabel(label: string): SpeciesKey | undefined {
  if ((SPECIES_KEYS as readonly string[]).includes(label)) {
    return label as SpeciesKey;
  }
  const fromIt = IT_LABEL_TO_KEY[label];
  if (fromIt) return fromIt;
  for (const key of SPECIES_KEYS) {
    if (speciesLabel(key) === label) return key;
  }
  return undefined;
}

export function speciesDisplayLabel(stored: string | null | undefined): string {
  if (!stored) return "";
  const key = speciesKeyFromLabel(stored);
  return key ? speciesLabel(key) : stored;
}

export function resolveSpeciesLabel(
  speciesSelect: HTMLSelectElement,
  otherInput: HTMLInputElement,
): string | undefined {
  const key = speciesSelect.value;
  if (!key) return undefined;
  if (key === "other") {
    const other = otherInput.value.trim();
    return other || speciesLabel("other");
  }
  return speciesLabel(key as SpeciesKey);
}

export function getBreedsForSpecies(speciesKeyOrLabel: string): string[] {
  const key = speciesKeyFromLabel(speciesKeyOrLabel) ?? speciesKeyOrLabel;
  if (!key || key === "other") return [];
  return [...(BREEDS_BY_KEY[key] ?? [])];
}

export function toggleSpeciesOtherField(
  speciesSelect: HTMLSelectElement,
  otherWrap: HTMLElement,
  otherInput: HTMLInputElement,
): () => void {
  const refresh = () => {
    const isOther = speciesSelect.value === "other";
    otherWrap.style.display = isOther ? "block" : "none";
    otherInput.required = isOther;
    if (!isOther) otherInput.value = "";
  };
  speciesSelect.addEventListener("change", refresh);
  refresh();
  return () => speciesSelect.removeEventListener("change", refresh);
}
